import { cn } from '../../utils/utils';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import Text from './Text';
import ViewItems from '../ViewItems';
import { useSelector } from 'react-redux';
import { getRejectedFieldData, getSectionRejectedFields } from '../../utils/functions';
import ErrorText from './ErrorText';

const RadioButton = ({ label, onClick, disabled, selected, className, isSquare = false, subText, subTextColor, subTextSize, subTextClasses, labelClasses, remarksMetadata = null, isShowRemarks = false, isReverse = true }) => {
  const { rejection_summary, is_rejected, field_codes } = useSelector((state) => state.corporate);

  const rejectedFields = getSectionRejectedFields(rejection_summary, remarksMetadata?.sectionId);
  const rejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, remarksMetadata?.key);
  const isFieldDisabled = disabled || (is_rejected && remarksMetadata && (!rejectedField?.remarks || rejectedField?.remarks?.length < 1));

  return (
    <>
      <ViewReverse
        className={cn('items-center gap-2 !cursor-pointer', isFieldDisabled && 'opacity-50 !cursor-not-allowed', className)}
        onClick={isFieldDisabled ? null : onClick}
        isReverse={isReverse}
      >
        <div
          className={cn(
            'border flex',
            isSquare ? 'rounded min-h-4 min-w-4 max-h-4 max-w-4' : 'rounded-full min-h-4 min-w-4 items-center justify-center',
            selected ? 'border-dark-blue' : 'border-grey',
            rejectedField?.remarks?.length > 0 && 'border-red-600',
          )}
        >
          {isSquare ? (
            <div className={cn('flex-1 flex items-center justify-center overflow-hidden', selected ? 'bg-dark-blue' : 'bg-transparent')}>
              {selected && <ReactSVG src={icons.check} />}
            </div>
          ) : (
            <div className={cn('h-1.5 w-1.5 bg-dark-blue rounded-full', selected ? 'flex' : 'hidden')} />
          )}
        </div>
        <ViewItems>
          <Text text={label} size={fontSizes.h14} className={labelClasses} />
          {subText && <Text text={subText} size={subTextSize} className={cn(subTextColor ?? 'text-primary-light', subTextClasses)} />}
        </ViewItems>
      </ViewReverse>
      {
        isShowRemarks && rejectedField?.remarks?.length > 0 && (
          <ViewReverse className='items-center gap-2 mt-2'>
            <ReactSVG src={icons.field_info_outline} />
            <ErrorText text={rejectedField?.remarks} className={'mt-0'} />
          </ViewReverse>
        )
      }
    </>
  );
};

export default RadioButton;
